import { useNavigate } from "react-router-dom";

const useNavigation = () => {
  const navigate = useNavigate();

  const navigateTo = (path, options = {}) => {
    if (!path || typeof path !== "string") {
      console.error("Invalid path provided for navigation");
      return;
    }
    navigate(path, options);
  };

  return { navigateTo };
};

export default useNavigation;
